module.exports = __webpack_public_path__ + "img/logo_yishiyong@2x.265b5985.png";